import { CloneScenarioRequest, CopyModelMaterialRequest, CreateScenarioRequest, UpdateScenarioRequest, Scenario, ScenariosClient, ProblemDetails } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const scenariosClient = new ScenariosClient(undefined, axios);

export const useScenarios = (projectId: string | undefined, options?: any) => {
  return useQuery<Scenario[]>({
    ...options,
    queryKey: ["scenarios", projectId],
    queryFn: async () => scenariosClient.getScenarios(projectId!),
    // TODO: before we can enable caching here, we need to ensure that any mutations (create, delete, update) properly invalidate or update the cache
    //staleTime: 30 * 60 * 1000, // 30 minutes
    //cacheTime: 60 * 60 * 1000, // 60 minutes      
  });
};

export const useScenario = (scenarioId: string | undefined | null, options?: any) => {
  return useQuery<Scenario>({
    ...options,
    queryKey: ["scenario", scenarioId],
    queryFn: async () => scenariosClient.getScenarioByID(scenarioId!),
    enabled: !!scenarioId,
  });
};

export const useCreateScenario = (options?: any) => {
  return useMutation<Scenario>({
    ...options,
    mutationFn: (createScenarioRequest: CreateScenarioRequest) => scenariosClient.createScenario(createScenarioRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["scenarios"], exact: false });
      options?.onSuccess?.();
    },
  });
};

export const useUpdateScenario = (options?: any) => {
  return useMutation<Scenario>({
    ...options,
    mutationFn: (updateScenarioRequest: UpdateScenarioRequest) => scenariosClient.updateScenarioSettings(updateScenarioRequest),
    onSuccess: async (data, variables) => {
     
      await queryClient.resetQueries({ queryKey: ["scenarios"], exact: false });
      
      options?.onSuccess?.(data, variables);
    },
  });
};

export const useDeleteScenario = (options?: any) => {
  return useMutation<void>({
    ...options,
    mutationFn: (scenarioId: string | undefined) => scenariosClient.deleteScenario(scenarioId!),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["scenarios"], exact: false });
      options?.onSuccess?.();
    },
  });
};


export const useEnableScenarioFinal = (options?: any) => {
  return useMutation<void>({
    ...options,
    mutationFn: ({ scenarioId, enableFinal }: { scenarioId: string; enableFinal: boolean }) => 
      scenariosClient.setFinalScenario(scenarioId, enableFinal),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["scenarios"], exact: false });
      options?.onSuccess?.();
    },
    onError: async (error:any) => {
       console.info(error);
      if(error && (error as ProblemDetails).detail)
      {
      console.error("Error enabling/disabling final scenario: " + error?.detail);
      }
    },
    
  });
};



export const useCloneScenario = (options?: any) => {
  return useMutation<void>({
    ...options,
    mutationFn: (cloneScenarioRequest: CloneScenarioRequest) => scenariosClient.cloneScenario(cloneScenarioRequest.scenarioId as any, cloneScenarioRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["scenarios"], exact: false });
      options?.onSuccess?.();
    },
  });
};


export const useCopyModelMaterials = (options?: any) => {
  return useMutation<void>({
    ...options,
    mutationFn: (copyModelMaterialRequest: CopyModelMaterialRequest) => scenariosClient.copyModelMaterials(copyModelMaterialRequest.dstModelId as any, copyModelMaterialRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["scenarios"], exact: false });
      options?.onSuccess?.();
    },
  });
};